export const parseJson = <T>(val?: string) =>
  JSON.parse(val === undefined || val === 'undefined' ? 'null' : val) as T;
